module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-brands-400.woff?1e4d5407864894d0da8d93ac43b3e32b";